import { Color, ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled, { css } from "styled-components";

export const CardsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(150px, 1fr));
  gap: 12px;
  flex: 1;
`;

export const Card = styled.button<{ $isHighlighted: boolean }>`
  appearance: none;
  border: 1px solid ${ColorV2.Blue6};
  border-radius: 12px;
  background: ${ColorV2.White};
  padding: 12px 16px;
  display: grid;
  grid-template-columns: 20px 1fr;
  column-gap: 14px;
  align-items: center;
  min-height: 90px;
  text-align: left;
  cursor: pointer;

  ${(props) =>
    props.$isHighlighted &&
    css`
      border: 2px solid ${ColorV2.Blue1};
      box-shadow: 0 6px 20px rgba(15, 42, 64, 0.08);
      padding: 11px 15px;
    `}
`;

export const IconSlot = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
`;

export const Value = styled.span<{ $color: Color | ColorV2 }>`
  ${TypographyV2.h5};
  color: ${(props) => props.$color};
  line-height: 1;
`;

export const Label = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue3};
  line-height: 1.2;
`;
